import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowLeft } from "@phosphor-icons/react";
import api from "@/lib/api";
import ItemCard from "@/components/ItemCard";

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/wishlist").then(r => setItems(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <main className="min-h-[calc(100vh-4rem)] bg-[#FDFBF7] py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-2xl bg-[#D96C4A]/10 flex items-center justify-center">
            <Heart size={24} weight="duotone" className="text-[#D96C4A]" />
          </div>
          <div>
            <h1 className="font-heading text-3xl sm:text-4xl font-medium text-[#1A1C1A] tracking-tight" data-testid="wishlist-heading">
              Saved Items
            </h1>
            <p className="text-sm text-[#5C665D]">{items.length} {items.length === 1 ? "item" : "items"} saved</p>
          </div>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="w-8 h-8 border-2 border-[#2C5545] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : items.length === 0 ? (
          <div className="text-center py-20 bg-white border border-[#EAE7E0] rounded-2xl" data-testid="wishlist-empty">
            <Heart size={48} weight="duotone" className="text-[#EAE7E0] mx-auto mb-4" />
            <p className="font-heading text-2xl text-[#1A1C1A] mb-2">No saved items yet</p>
            <p className="text-sm text-[#5C665D] mb-6">Tap the heart icon on any item to save it here.</p>
            <Link to="/browse" className="bg-[#2C5545] text-white rounded-full px-6 py-2.5 text-sm font-medium hover:bg-[#224235] transition-all inline-block" data-testid="wishlist-browse-link">
              Browse Items
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {items.map(item => <ItemCard key={item.id} item={item} />)}
          </div>
        )}
      </div>
    </main>
  );
}
